import { Injectable } from '@angular/core';
import { Model } from '@shared/graphql/generated';
import { BaseStoreService } from '@shared/stores/base-store.service';

@Injectable({
  providedIn: 'root'
})
export class FavoriteModelStoreService extends BaseStoreService<Model> {
  constructor() {
    super();
  }
}
